"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var priceBuilder = function priceBuilder(params, context) {
  if (context === null || context === void 0 ? void 0 : context.withoutPrice) {
    return '';
  }

  var priceMinFilter = params.priceMin ? "priceEUR>=" + Math.floor(params.priceMin / 100) : '';
  if (context === null || context === void 0 ? void 0 : context.withDynamicMinimumPrice) priceMinFilter = params.priceMin ? "minPrice>=" + Math.floor(params.priceMin / 100) : '';
  var priceMaxFilter = params.priceMax ? "priceEUR<=" + Math.ceil(params.priceMax / 100) : '';
  return [priceMinFilter, priceMaxFilter].filter(Boolean).join(' AND ');
};

var _default = priceBuilder;
exports["default"] = _default;